import {Component, ChangeDetectionStrategy, Input, Output, EventEmitter, HostBinding} from '@angular/core';

import {RpControlsSettingsService} from '../rp-controls-settings.service';


export class RpControlsDropdownComponent {
  
  
  open = false;

   overlayClick = new EventEmitter();

  dropdown = this.settings.dropdown;

  constructor(private settings: RpControlsSettingsService) {}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'rp-controls-dropdown',
  styles: [`
    :host {
      position: absolute;
      display: none;
      left: 0;
      z-index: 1000;
      box-shadow:
        0 5px 5px -3px rgba(0,0,0,.2),
        0 8px 10px 1px rgba(0,0,0,.14),
        0 3px 14px 2px rgba(0,0,0,.12)
      ;
      background-color: white;
    }

    :host.is-open {
      display: block;
    }

    rp-controls-overlay {
      z-index: initial !important;
    }

    .content {
      position: relative;
    }
  `],
  template: `
    <rp-controls-overlay [open]="open" (click)="overlayClick.emit()" [opacity]="dropdown.opacity"></rp-controls-overlay>

    <div class="content">
      <ng-content></ng-content>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: RpControlsSettingsService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'open': [{ type: Input },{ type: HostBinding, args: ['class.is-open', ] },],
'overlayClick': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
